import { render, staticRenderFns } from "./calendar-editor.vue?vue&type=template&id=31fed476&"
import script from "./calendar-editor.vue?vue&type=script&lang=js&"
export * from "./calendar-editor.vue?vue&type=script&lang=js&"
import style0 from "./calendar-editor.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports